import { render } from "./CarouselSlide.vue?vue&type=template&id=533c456c"
import script from "./CarouselSlide.vue?vue&type=script&lang=js"
export * from "./CarouselSlide.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__